import request from '@/utils/request'
export function getDataList(data) {
  return request({
    url: `/courseManage/getList`,
    method: 'post',
    data,
  })
}
//获取所有老师
export function getTeachers() {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}
// 添加保存
export function AddSave(data) {
  return request({
    url: `/courseManage/add`,
    method: 'post',
    data
  })
}
// 编辑保存
export function editSave(data) {
  return request({
    url: `/courseManage/update`,
    method: 'post',
    data
  })
}
//编辑回显
export function getDetails(id) {
  return request({
    url: `/courseManage/detail?id=${id}`,
    method: 'get',
  })
}
//删除
export function delItem(id) {
  return request({
    url: `/courseManage/del?id=${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/StudentManagementApi.js